// Location service — backs LocationSelector. The continent→country tree is bundled reference data
// (src/data/locationData.json); states/cities are fetched from the backend and cached via TanStack
// Query so the multiple geo rows share one cache.
import { http } from '@/services/http';
import { endpoints } from '@/services/endpoints';
import type { LocationData, CountryRegion, LocationSearchResult } from '@/types';
import locationData from '@/data/locationData.json';

export interface LocationService {
  getLocationData(): LocationData;
  getStates(countryCode: string): Promise<string[]>;
  getCities(state: string, countryCode?: string, q?: string): Promise<string[]>;
  getRegions(country: string): Promise<CountryRegion[]>;
  /** One search over continents, countries, regions, states and cities (2+ characters). */
  search(q: string): Promise<LocationSearchResult[]>;
}

export const locationService: LocationService = {
  getLocationData: () => locationData as LocationData,
  getStates: (countryCode) =>
    http<string[]>(`${endpoints.locations.states}?country=${encodeURIComponent(countryCode)}`),
  getCities: (state, countryCode, q) => {
    const params = new URLSearchParams({ state });
    if (countryCode) params.set('country', countryCode);
    if (q?.trim()) params.set('q', q.trim());
    return http<string[]>(`${endpoints.locations.cities}?${params.toString()}`);
  },
  getRegions: (country) =>
    http<CountryRegion[]>(`${endpoints.locations.regions}?country=${encodeURIComponent(country)}`),
  search: (q) =>
    http<LocationSearchResult[]>(`${endpoints.locations.search}?q=${encodeURIComponent(q)}`),
};
